import router from './router';
import store from './store'


router.beforeEach((to, from, next) => {
    store.commit('setCurrentRoute',to.path)
   
    store.dispatch('user/getMenuInfo');
    next()
      
});
  
